
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternatives/zixflow",
      function () {
        return require("private-next-pages/alternatives/zixflow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternatives/zixflow"])
      });
    }
  